import React from 'react';
import { Modal } from '../../../Modal';
import { UserComparisons } from '../UserComparisons';
import { Inner } from './partials';
export var UserComparisonsModal = function UserComparisonsModal(_ref) {
  var onSelect = _ref.onSelect,
    onDelete = _ref.onDelete,
    show = _ref.show,
    userComparisons = _ref.userComparisons,
    onClose = _ref.onClose;
  return React.createElement(Modal, {
    show: show,
    onClose: onClose
  }, React.createElement(Inner, null, React.createElement(UserComparisons, {
    userComparisons: userComparisons,
    onSelect: onSelect,
    onDelete: onDelete,
    withTitle: true
  })));
};